import groupBy from 'lodash/groupBy'
import type { Dispatch } from 'react'
import React, { useContext as useContextCore } from 'react'
import merge from 'lodash/merge'
import type { Components } from './components'
import { components as defaultComponents } from './components'
import type { CalendarOptions, EventInput, EventSourceInput } from '@fullcalendar/core'
// eslint-disable-next-line lodash/import-scope
import type { Dictionary } from 'lodash'

export type ProviderProps = {
  setCalendarDate?: (args: { currentStart: Date; currentEnd: Date }) => void
  showFilter?: boolean
  children: React.ReactNode
  components?: Components
} & CalendarOptions

export type ContextType = {
  groupedEvents: Dictionary<EventInput[]>
  displayEvents: EventSourceInput
  setDisplayEvents: Dispatch<EventSourceInput>
} & Omit<ProviderProps, 'children'>

const context = React.createContext<ContextType>({} as ContextType)
const CoreProvider = context.Provider

export const Provider = ({ events, timeZone, setCalendarDate, children, showFilter = false, components, ...props }: ProviderProps) => {
  components = merge({}, defaultComponents, components)

  const [displayEvents, setDisplayEvents] = React.useState<EventSourceInput>()

  const [groupedEvents, setGroupedEvents] = React.useState({})
  React.useEffect(() => {
    setDisplayEvents(events)
    const groupedByType = groupBy(events as EventInput[], (item) => {
      return [item?.extendedProps?.type]
    })
    setGroupedEvents(groupedByType)
  }, [events])

  return (
    <CoreProvider value={{ timeZone, setCalendarDate, groupedEvents, displayEvents, setDisplayEvents, showFilter, components, ...props }}>
      {children}
    </CoreProvider>
  )
}

export const useContext = () => useContextCore(context)
